import { SortDirection } from '~/types/Shared'

export enum CallTableColumn {
  DateTime = 'dateTimeColumn',
  Outcome = 'outcomeColumn',
  To = 'toColumn',
  From = 'fromColumn',
  ToFrom = 'toFromColumn',
  Contact = 'contactColumn',
  Duration = 'durationColumn',
  Transcript = 'transcriptColumn',
}

export type CallTableColumnSorting = {
  column: CallTableColumn
  direction?: SortDirection
}

//used to build singularly-sorted columns, this will go away if multi-ordering becomes available
export const buildCallTableColumnSorting = (
  column: CallTableColumn,
  direction: SortDirection,
) => {
  switch (column) {
    case CallTableColumn.DateTime:
      return [
        { column, direction },
        { column: CallTableColumn.Duration, direction: undefined },
      ]
    case CallTableColumn.Duration:
      return [
        { column, direction },
        { column: CallTableColumn.DateTime, direction: undefined },
      ]
  }

  return undefined
}
